import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesTournament } from "../../../utils/types/TalesTournament";
import { db } from "../../../firebase/config";

export const deleteTournament = createAsyncThunk(
  "tournament/delete",
  async (tournament: TalesTournament) => {
    try {
      const querySnapshot = await db
        .collection("tournament")
        .where("title", "==", tournament.title)
        .where("data", "==", tournament.data)
        .where("area", "==", tournament.area)
        .where("ora", "==", tournament.ora)
        .get();

      return await querySnapshot.docs[0].ref.delete();
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Torneo non eliminato, ${e.message}`);
    }
  },
);
